import React from 'react'
import LocalizedSelectArrayInput from 'ui-shared/LocalizedFields/LocalizedSelectArrayInput'
import { useKGetList } from 'services/hooks/useKGetList'

const LogisticSelectInput: React.FC = () => {
  const choices = useKGetList('logistics')

  return (
    <LocalizedSelectArrayInput
      source="logistics"
      label="Catering Logistics"
      choices={choices}
      // Quickfix: defaultValue was breaking the behaviour of the component, we should study it and re-add it later
      // defaultValue={[choices[0].id]}
      fullWidth
    />
  )
}

export default LogisticSelectInput
